import { Box } from "@mui/material";
import type { JSX } from "react";

import { HarvesterActivity } from "../components/AgentTrackPanels.js";

/**
 * The contact-harvester's "consciousness", shown inside `<BrainSection>` when
 * the agent is in **contacts** (or both) mode. The lead agent's
 * Plan/Act/Observe transcript (`ChatActivity`) is meaningless for the
 * harvester, which thinks in enumerate → dig → dedup → promote beats; this
 * surfaces that live feed instead.
 *
 * It used to carry its own "Working through the target map" coverage bar. That
 * was dropped 2026-08-07 when the Brain tab moved into the Status page: the
 * **Target coverage** card (`status/HarvesterStatus.tsx`) now sits directly
 * above under the same `showContacts` condition, so a second copy of the same
 * bar would be pure duplication.
 */
export function HarvesterBrain(): JSX.Element {
  return (
    <Box sx={{ minHeight: 0 }}>
      <HarvesterActivity
        heading="Live activity — what the harvester is doing"
        maxHeight="calc(100dvh - 320px)"
      />
    </Box>
  );
}
